import { render, staticRenderFns } from "./MasterGroupClassDetails.vue?vue&type=template&id=d04386ac"
import script from "./MasterGroupClassDetails.vue?vue&type=script&lang=js"
export * from "./MasterGroupClassDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports